<template>
  <div>
    <portal to="mobileMenuButton">
      <v-btn icon @click.prevent="$router.push('/clientes')">
        <app-icon>navigate_before</app-icon>
      </v-btn>
    </portal>
    <v-row>
      <v-col class="pr-md-2" cols="12" md="3">
        <CustomerProfileStatsSection class="mb-4" :customer="customer" :stats="stats"
          :dueTransactionsSum="dueTransactionsSum" />
        <v-alert class="mb-5" text type="info" style="border-radius: 16px !important;"
          v-if="showNoSelectedProfessionalAlert">
          Nenhum profissional selecionado
          <br />
          <small>Selecione um profissional para ter acesso aos dados clínicos do
            {{ customerAlias.toLowerCase() }}.</small>
        </v-alert>
        <v-card outlined class='mb-5'>
          <v-card-text class="pa-4">

            <v-list class="px-0" nav dense rounded v-model="visibleSection" style="width:100%">
              <v-list-item-group color="primary">
                <template v-for="link in links">

                  <v-list-item v-if="link.permission" :key="link.url"
                    @click="handleShowSection(link.url, link.title, link.callback)">
                    <v-list-item-icon>
                      <app-icon class="ml-2">{{ link.icon }} </app-icon>
                    </v-list-item-icon>
                    <v-list-item-content>
                      <v-list-item-title> {{ link.title }} </v-list-item-title>
                    </v-list-item-content>
                    <v-list-item-icon>
                      <app-icon>navigate_next</app-icon>
                    </v-list-item-icon>
                  </v-list-item>
                </template>
              </v-list-item-group>
            </v-list>
          </v-card-text>
        </v-card>
        <div class="d-flex justify-center d-none d-md-flex mt-5">
          <app-btn small color="primary" @click="handleCustomerExport()">
            <app-icon left>download </app-icon> Exportar
          </app-btn>
        </div>
      </v-col>
      <v-col class="pl-md-2" v-if="!$vuetify.breakpoint.mobile" cols="12" md="9">
        <v-row>
          <v-col cols="12">
            <CustomerFormSection :customer="customer" ref="CustomerFormSection"
              v-show="visibleSection == '/cliente/ficha-cadastral'" @store="setCustomer($event)" />
            <CustomerProfessionalRecordForm @input="update()" ref="CustomerProfessionalRecordForm"
              v-show="visibleSection == '/cliente/prontuario'" @delete="select()" :customer="customer" />
            <CustomerAnamneseForm @input="update()" ref="CustomerAnamneseForm"
              v-show="visibleSection == '/cliente/anamnese'" @delete="select()" :customer="customer" />
            <CustomerSessions ref="CustomerSessions" v-show="visibleSection == '/cliente/sessoes'"
              :customer="customer" />
            <CustomerBills ref="CustomerBills" v-show="visibleSection == '/cliente/financeiro'" :customer="customer"
              @store="select($event)" />
            <CustomerDocumentsSection ref="CustomerDocumentsSection" :customer="customer"
              v-show="visibleSection == '/cliente/documentos'" />
            <CustomerFileSection ref="CustomerFileSection" :customer="customer"
              v-show="visibleSection == '/cliente/arquivos'" />
            <CustomerBillingsNotificationsSection ref="CustomerBillingsNotificationsSection"
              v-show="visibleSection == '/cliente/notificacoes-cobranca'" :customer="customer" />
          </v-col>
        </v-row>
      </v-col>
    </v-row>
  </div>
</template>
<script>

import CustomerFormSection from "@/components/v2/customers/forms/CustomerFormSection.vue";
import CustomerProfileStatsSection from "@/components/v2/customers/sections/CustomerProfileStatsSection.vue";

import CheckUnsavedChangesMixin from "@/mixins/App/CheckUnsavedChangesMixin";
import CustomerAnamneseForm from "@/components/customers/forms/CustomerAnamneseForm.vue";
import CustomerSessions from "@/components/customers/sections/CustomerSessions.vue";
import CustomerBills from "@/components/customers/sections/CustomerBills.vue";
import CustomerDocumentsSection from "@/components/customers/sections/CustomerDocumentsSection.vue";
import CustomerProfessionalRecordForm from "@/components/customers/forms/CustomerProfessionalRecordForm.vue";
import CustomerFileSection from "@/components/customers/sections/CustomerFileSection.vue";
import CustomerBillingsNotificationsSection from "@/components/customers/sections/CustomerBillingsNotificationsSection.vue";
import { customerAlias } from "@/utils/customerAlias";

export default {
  mixins: [CheckUnsavedChangesMixin],

  components: {
    CustomerFormSection,
    CustomerProfileStatsSection,
    CustomerAnamneseForm,
    CustomerSessions,
    CustomerBills,
    CustomerDocumentsSection,
    CustomerProfessionalRecordForm,
    CustomerFileSection,
    CustomerBillingsNotificationsSection,
  },

  data() {
    return {
      customerAlias: customerAlias(),

      visibleSection: "/cliente/ficha-cadastral",

      sectionTitle: "Dados principais",

      customer: {},

      customerProfessionalId: null,

      dueTransactionsSum: 0,

      stats: {},

      active: null,


    };
  },

  created() {
    this.select();

    this.getStats();
  },

  computed: {
    isClinic() {
      return this.$acl.isClinic();
    },

    showCustomerBills() {
      return (
        this.$acl.isProfessional() || this.$acl.can("can_access_financial")
      );
    },

    canViewCustomerSensitiveData() {
      return this.$acl.canViewCustomerSensitiveData(
        this.customerProfessionalId
      );
    },

    showNoSelectedProfessionalAlert() {
      if (this.customer.id) {
        return this.isClinic && this.customer.professional == null;
      }
    },

    isEditing() {
      return this.$store.state.app.isEditing;
    },

    links() {
      return [

        {
          title: 'Dados principais',
          url: '/cliente/ficha-cadastral',
          icon: 'mdi-account',
          permission: true,
          callback: ''
        },
        {
          title: 'Prontuário',
          url: '/cliente/prontuario',
          icon: 'mdi-clipboard-text-outline',
          permission: this.canViewCustomerSensitiveData,
          callback: ''
        },

        {
          title: 'Anamnese',
          url: '/cliente/anamnese',
          icon: 'mdi-forum-outline',
          permission: this.canViewCustomerSensitiveData,
          callback: ''
        },
        {
          title: 'Anotações da Sessão',
          url: '/cliente/sessoes',
          icon: 'mdi-pencil',
          permission: true,
          callback: () => this.getSessions()
        },

        {
          title: 'Financeiro',
          url: '/cliente/financeiro',
          icon: 'mdi-currency-usd',
          permission: this.$acl.canViewTransactions(),
          callback: () => this.getBills()
        },
        {
          title: "Cobranças",
          url: "/cliente/notificacoes-cobranca",
          icon: "mdi-bell-outline",
          permission: true,
          callback: () => this.getBillingsNotifications()
        },
        {
          title: 'Documentos',
          url: '/cliente/documentos',
          icon: 'mdi-file-document-outline',
          permission: true,
          callback: () => this.getDocuments()
        },
        {
          title: 'Arquivos',
          url: '/cliente/arquivos',
          icon: 'mdi-file',
          permission: true,
          callback: () => this.getFiles()
        }
      ]
    },
  },

  methods: {
    handleShowSection(route, sectionTitle, callback = null) {
      if (this.$vuetify.breakpoint.mobile) {
        this.$router.push(route + "/" + this.$route.params.id);
      } else {
        this.sectionTitle = sectionTitle;
        this.visibleSection = route;
        if (callback) {
          callback();
        }
      }
    },

    async select(page = 1) {
      this.$loading.start();
      await this.$http
        .show("customer/customer", this.$route.params.id)
        .then((response) => {
          this.customer = response.customer;
          this.customerProfessionalId = response.customer.professional_id;
          this.dueTransactionsSum = response.due_transactions_sum;
          // this.getBills();
          // this.getSessions();
          this.$loading.finish();
        })
        .catch((error) => {
          this.$loading.finish();
        });
    },

    getStats() {
      let params = {
        customer_id: this.$route.params.id,
      };

      this.$http
        .index("sessions/session-stats", params)
        .then((response) => {
          this.stats = response.stats;
        })
        .catch((error) => {
          console.log(error);
        });
    },

    setCustomer(customer) {
      this.customer = customer;
      this.customerProfessionalId = customer.professional_id;

      this.select();

    },

    getSessions() {
      this.$refs.CustomerSessions.select();
    },
    getBills() {
      this.$refs.CustomerBills.select();
    },
    getDocuments() {
      this.$refs.CustomerDocumentsSection.select();
    },

    getFiles() {
      this.$refs.CustomerFileSection.select();
    },
    getBillingsNotifications() {
      this.$refs.CustomerBillingsNotificationsSection.select();
    },

    handleCustomerExport() {
      this.$loading.start();
      this.$http
        .download("customer/customer-export", {
          customer_id: this.customer.id,
        })
        .then((response) => {
          const url = window.URL.createObjectURL(new Blob([response.data]));
          const link = document.createElement("a");
          link.href = url;
          link.setAttribute(
            "download",
            `Ficha do ${customerAlias()} :${this.customer.name}.xlsx`
          );
          document.body.appendChild(link);
          link.click();
          this.$loading.finish();
        })
        .catch((error) => {
          console.log(error);
          this.$loading.finish();
        });
    },
  },
};
</script>

<style></style>
